import router from '@/router'
import { cmsPage } from '@/cmsPages'

const getDefaultState = () => ({
  downloadAreaAgreed: false,
  order: null,
  preloaded: false
})

const state = getDefaultState()

const getters = {
}

const openExternal = (url) => {
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

const actions = {
  changePassword () {
    router.push({ name: 'set-password' })
  },
  downloadInvoice ({ dispatch }, order) {
    dispatch('orderFormService/downloadInvoicePDF', {
      orderId: order.id
    }, { root: true })
  },
  forgotPassword ({ commit }) {
    router.push({ name: 'reset-password' })
  },
  goBack () {
    router.back()
  },
  async newOrder ({ commit, dispatch }) {
    // we don't need this because the backend persists the state
    // commit('orderForm/clearProductQuantities', null, { root: true })
    router.push({ name: 'new-order' })
  },
  async preload ({ state, commit, dispatch, rootGetters }) {
    // prevent calling preload twice
    if (state.preloaded === false) {
      commit('setPreloaded', true)
      dispatch('orderFormService/getOrders', null, { root: true })
      // Order form is now loaded on-demand in NewOrderV2 component
      // No need to preload it here
    }
  },
  showConfirmation ({ commit }) {
    router.push({ name: 'order-confirmation' })
  },
  showCustomerNews () {
    openExternal(cmsPage('news'))
  },
  showDeliveryAddress () {
    router.push({ name: 'delivery-address' })
  },
  showDownloadArea ({ state }) {
    if (!state.downloadAreaAgreed) {
      router.push({ name: 'download-agree' })
      return
    }
    openExternal(cmsPage('download'))
    if (router.currentRoute.name === 'download-agree') {
      router.push({ name: 'menu' })
    }
  },
  showLogin ({ commit }) {
    router.push({ name: 'login' })
  },
  showMenu ({ commit, rootState }) {
    router.push({ name: 'menu' })
  },
  showOrderHistory ({ commit }) {
    router.push({ name: 'order-history' })
  },
  showOrder ({ commit }, { order }) {
    commit('setOrder', {
      order: order
    })
    router.push({ name: 'view-order' })
  },
  showPayment () {
    router.push({ name: 'payment' })
  },
  showStartPage ({ commit }) {
    router.push({ name: 'index' })
  },
  async startOrderFlow ({ dispatch }) {
    // all logic related to new order is in orderForm module
    await dispatch('orderForm/startOrderFlow', null, { root: true })
  }
}

const mutations = {
  reset (state) {
    Object.assign(state, getDefaultState())
  },
  setDownloadAreaAgreed (state, agreed) {
    state.downloadAreaAgreed = agreed
  },
  setOrder (state, { order }) {
    state.order = order
  },
  setPreloaded (state, preloaded) {
    state.preloaded = preloaded
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
